import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DialogCalendarComponent, DialogComponent, DialogFilterComponent} from '@shared/module/dialog/component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FormsModule} from '@angular/forms';
import {MatDialogModule} from "@angular/material/dialog";


@NgModule({
  declarations: [
    DialogComponent,
    DialogFilterComponent,
    DialogCalendarComponent
  ],
    imports: [
        CommonModule,
        DragDropModule,
        TranslateModule,
        MatButtonToggleModule,
        FormsModule,
        MatDialogModule
    ],
  exports: [
    DialogComponent,
    DialogFilterComponent,
    DialogCalendarComponent
  ]
})
export class DialogModule {
}
